import { graphql } from 'react-relay';

export const gqlUpdateAddOn = graphql`
  mutation updateAddOnMutation($product: SuperposherBusinessProduct!, $quantity: Int!) {
    superposherUpdateAddOn(product: $product, quantity: $quantity) {
      success
    }
  }
`;
